import React from 'react';

function ArrowSmallRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#374957"
        d="M17.414 10.586l-4.293-4.293-1.414 1.414L15 11H5v2h10l-3.293 3.293 1.414 1.414 4.293-4.293a2 2 0 000-2.828z"
      ></path>
    </svg>
  );
}

export default ArrowSmallRightIcon;
